import {
  UseIcon,
  type UseIconProps,
} from 'assets/Icon.js';
import type { FC } from 'react';

export const CloseIcon: FC<UseIconProps> = (props) => {
  return (
    <UseIcon
      sx={{
        fontSize: '20px',
        color: theme => theme.palette.common.white,
      }}
      svgProps={{
        width: 22,
        height: 22,
        viewBox: '0 0 22 22',
      }}
      icon="modalCloseSvg"
      {...props}
    />
  );
};
